<template>
    <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile" >
      <NavBar />
      <div class="block block__commercial">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <SidebarSearch />
      <div class="block block__commercial">
        <div>
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
        </div>
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->

</template>


<script>
import SidebarSearch from '../../module/sidebar/SidebarSearch'
import CatMixin from './CatMixin'
import NavBar from '../../module/Navbar'

export default {
  name:"commercials",
    components:{
        SidebarSearch,
        NavBar
    },  
    mixins: [
      CatMixin
    ],    
  data () {
    return {
    }
  },
  methods : {}
};
</script>
